import React, { useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

import orangenode from "../../assets/oragenode.svg";
import rednode from "../../assets/rednode.svg";
import greennode from "../../assets/greennode.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";



const Linegraph = ({trendtype, setTrendType, attendancetrend}) => {

  


const allDates = new Set();
Object.values(attendancetrend).forEach(arr => {
  arr.forEach(item => allDates.add(item.date));
});

// Step 2: Convert to sorted array
const sortedDates = Array.from(allDates).sort();

// Step 3: Map each date to output format
const linedata = sortedDates.map(dateStr => {
  const dateObj = new Date(dateStr);
  const formattedDate = dateObj.toLocaleString('en-US', { month: 'short', day: 'numeric' });

  const getValue = (group) => {
    const found = attendancetrend[group]?.find(item => item.date === dateStr);
    return found ? found.value : 0;
  };

  return {
    date: formattedDate,
    CONSTRUCTION: getValue("CONSTRUCTION"),
    ENGINEERING:getValue("ENGINEERING") ,
    'I&E': getValue("INSTRUMENTATION & ELECTRICAL (I&E)")
  };
});

const POINT_WIDTH = 60; // reduced from 80 to shrink width per point
const HEIGHT = 220; // reduced height for smaller chart
const chartWidth = Math.max(POINT_WIDTH * linedata.length, 400); // reduced min width
  const options = [
    { key: "on_time", label: "On Time" },
    { key: "late", label: "Late" },
    { key: "absent", label: "Absent" },
  ];

  return (
    <div className='px-4 rounded-[12.75px] border border-black/10 bg-white shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10),0px_1px_2px_-1px_rgba(0,0,0,0.10)] py-8' style={{ width: "100%", maxWidth: "900px"}}>
      {/* Header and filters */}
<div className="w-full mb-6 text-left flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
  {/* Left text block */}
  <div className="flex-shrink-0">
    <h1 className="text-xl font-semibold">Attendance Trends</h1>
    <div className="flex items-center gap-1  text-sm text-[#717182]">
      <div>Daily attendance metrics by company</div>
    </div>
  </div>

  {/* Right side container */}
  <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 flex-shrink-0 w-full sm:w-auto">
    {/* Buttons + filter icon row */}
    <div className="flex items-center gap-2 flex-wrap sm:flex-nowrap">
      <div className="bg-[#DBEAFE] rounded-lg flex gap-2 p-1 flex-shrink-0">
        {options.map((option) => {
          const isSelected = trendtype === option.key;
          return (
            <button
              key={option.key}
              onClick={() => setTrendType(option.key)}
              className={`
                cursor-pointer border-0 rounded-md px-2 py-1 text-xs
                transition duration-300
                ${isSelected ? "bg-white shadow-md text-black" : "bg-transparent text-[#717182]"}
              `}
            >
              {option.label}
            </button>
          );
        })}
      </div>

      <FontAwesomeIcon icon={faFilter} size="lg" className="ml-2 flex-shrink-0" />
    </div>

    {/* Colored labels row */}
    <div className="flex gap-2 flex-nowrap flex-shrink-0">
      {[
        { color: "#F54900", label: "Construction" },
        { color: "#009689", label: "Engineering" },
        { color: "#FD9A00", label: "I&E" },
      ].map(({ color, label }) => (
        <div
          key={label}
          className="border rounded-full py-1 px-2 inline-flex items-center gap-1 whitespace-nowrap"
          style={{ borderColor: color }}
        >
          <span
            className="w-2 h-2 rounded-full"
            style={{ backgroundColor: color }}
          />
          {label}
        </div>
      ))}
    </div>
  </div>
</div>





      {/* Chart container */}
      <div style={{ display: "flex", alignItems: "flex-start" }}>
        {/* Left Y axis */}
        <div style={{ width: 50, height: HEIGHT }}>
          <LineChart
            width={50}
            height={HEIGHT}
            data={linedata}
            margin={{ top: 20, right: 0, left:-10, bottom: 5 }}
          >
            <YAxis
              domain={[0, 100]}
              tickFormatter={(tick) => `${tick}%`}
              ticks={[0, 25, 50, 75, 100]}
            />
          </LineChart>
        </div>

        {/* Main Line Chart with scroll */}
    <div
  style={{
    overflowX: "auto",
    width: "100%",
  }}
>
  <div
    style={{
      minWidth: `${POINT_WIDTH * linedata.length}px`,
      width: "100%",
      height: HEIGHT,
    }}
  >
    <ResponsiveContainer width="100%" height="100%">
      <LineChart
        data={linedata}
        margin={{ top: 20, right: 30, left: 23, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis hide />
        <Tooltip formatter={(value) => `${value}%`} />
        <Line type="monotone" dataKey="CONSTRUCTION" stroke="#009689" strokeWidth={2} dot={false} />
        <Line type="monotone" dataKey="ENGINEERING" stroke="#FD9A00" strokeWidth={2} dot={false} />
        <Line type="monotone" dataKey="I&E" stroke="#F54900" strokeWidth={2} dot={false} />
      </LineChart>
    </ResponsiveContainer>
  </div>
</div>

      </div>

      {/* Legend below chart in a single row */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "2rem",
          marginTop: "1rem",
          flexWrap: "nowrap",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <img src={greennode} alt="Green" width={12} height={12} />
          <span>Construction</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <img src={orangenode} alt="Orange" width={12} height={12} />
          <span>Engineering</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <img src={rednode} alt="Red" width={12} height={12} />
          <span>I&E</span>
        </div>
      </div>
    </div>
  );
};

export default Linegraph;
